import React, { useState, useEffect, useRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as am4core from "@amcharts/amcharts4/core";
import { montarGraficoClusteredColumnMensal } from "../../common/graficos/montarGraficoClusteredColumnMensal.js";
import Button from "../../common/button/button.jsx";
import Grid from "../../common/layout/grid.jsx";

import { gerarRelatorio } from "../../fatura/faturaActions.js";
import { RowFlex } from "../../common/layout/RowFlex.jsx";

function GraficoSaldoGeracaoComponent(props) {
    const graficoRef = useRef(null);
    const [graficoGeracaoSaldo, setGraficoGeracaoSaldo] = useState(null);

    useEffect(() => {
        atualizarListaGraficoGeracaoSaldo();
        return () => {
            if (graficoGeracaoSaldo) {
                graficoGeracaoSaldo.dispose();
            }
        };
    }, [props.listaGraficoGeracaoSaldo]);

    return (
        <div style={{ width: "100%", height: "100%" }}>
            <RowFlex style={{ justifyContent: "flex-end" }}>
                <Grid cols="12 4 4 2">
                    <Button
                        text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 1rem)", whiteSpace: "nowrap" }}>Imprimir</span>}
                        type={"info"}
                        icon={"fas fa-print"}
                        event={(e) => {
                            handleExport(graficoRef);
                        }}
                    />
                </Grid>
            </RowFlex>
            <div
                className="custom-scroll"
                style={{
                    overflowX: "scroll",
                    width: "100%",
                    height: "100%",
                    justifyContent: window.innerWidth <= 768 ? "flex-start" : "center",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                <div ref={graficoRef} id="grafico-geracao-saldo" style={{ width: "100%", minWidth: "890px", height: "500px" }}></div>
            </div>
        </div>
    );

    async function handleExport(graficoRef) {
        const getTamanhoBase = () => {
            const zoomAtual = Math.floor(window.devicePixelRatio * 100);
            let tamanhoBase = 1750;
            if (window.innerWidth >= 768) {
                if (zoomAtual > 80 && zoomAtual <= 100) {
                    tamanhoBase = 1820;
                } else if (zoomAtual > 75 && zoomAtual <= 80) {
                    tamanhoBase = 1850;
                } else if (zoomAtual >= 70 && zoomAtual <= 75) {
                    tamanhoBase = 1900;
                } else if (zoomAtual >= 60 && zoomAtual <= 70) {
                    tamanhoBase = 2050;
                } else if (zoomAtual >= 50 && zoomAtual <= 60) {
                    tamanhoBase = 2450;
                } else if (zoomAtual < 50) {
                    return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                }

                if (zoomAtual > 100 && zoomAtual <= 110) {
                    tamanhoBase = 1850;
                } else if (zoomAtual > 110 && zoomAtual <= 125) {
                    tamanhoBase = 1870;
                } else if (zoomAtual > 125 && zoomAtual <= 150) {
                    tamanhoBase = 2500;
                } else if (zoomAtual > 150 && zoomAtual <= 175) {
                    tamanhoBase = 4900;
                } else if (zoomAtual > 175) {
                    return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                }
            }
            return tamanhoBase;
        };
        const calcularWidthGrafico = ({ el, desconto = 0 }) => {
            if (window.innerWidth < 768) {
                el.style.width = 900 - desconto + "px";
            } else {
                el.style.width = `${(window.devicePixelRatio < 1 ? 1 + (1 - window.devicePixelRatio) : 2 - window.devicePixelRatio) * getTamanhoBase() - desconto}px`;
                if (getTamanhoBase() == 2500) {
                    el.style.paddingLeft = "70px";
                    el.style.width = 1180 - desconto + "px";
                }
                if (getTamanhoBase() == 4900) {
                    el.style.paddingLeft = "120px";
                    el.style.width = 1105 - desconto + "px";
                }
            }
        };

        const formatarGrafico = ({ el }) => {
            if (el) {
                el.style.fontSize = "0.8rem";
                calcularWidthGrafico({ el });
                el.style.overflowY = "hidden";
            }
        };

        if (graficoRef.current) {
            formatarGrafico({ el: graficoRef.current });

            const html = `<div style="width:100%; height:70%; display:flex; align-items:center; justify-content:center;margin-top:10%;">` + graficoRef.current.outerHTML + "</div>";

            // Gera o relatório com o HTML atualizado

            await props.gerarRelatorio({
                html,
                landscape: true,
                scale: window.innerWidth < 768 ? 0.82 : window.devicePixelRatio * 0.62,
            });
        } else {
            console.error("Gráfico não está acessível.");
        }
    }

    function atualizarListaGraficoGeracaoSaldo() {
        const graficoGeracaoSaldoAtualizado = montarGraficoClusteredColumnMensal({
            state: {
                mobile: window.innerWidth < 768,
                cores: [
                    am4core.color("#ffa462"),
                    am4core.color("#77fdff"),
                    am4core.color("#0084ff"),
                    am4core.color("#a198ff"),
                    am4core.color("#fdff6a"),
                    am4core.color("#ff5e76"),
                    am4core.color("#2cffb9"),
                ],
            },
            component: graficoGeracaoSaldo,
            nome: "grafico-geracao-saldo",
            dados: props.listaGraficoGeracaoSaldo,
            titulo: "Saldo de Geração (kWh)",
            prefixo: "",
            sufixo: "kWh",
            exportar: false,
            fontColor: "#000",
        });
        setGraficoGeracaoSaldo(graficoGeracaoSaldoAtualizado);
    }
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            gerarRelatorio,
        },
        dispatch
    );

export const GraficoSaldoGeracao = connect(null, mapDispatchToProps)(GraficoSaldoGeracaoComponent);
